export default __webpack_public_path__ + "static/media/Baby48.bfe1a13f.gif";